import { join } from 'lodash';
import moment from 'moment';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatArgForLog = (arg: { [key: string]: any }): string => {
  const argType = typeof arg;

  switch (argType) {
    case 'string':
      return `"${arg}"`;
    case 'object':
      if (arg === null) {
        return 'null';
      } else if (moment.isMoment(arg)) {
        return `moment("${arg.format()}")`;
      } else if (Array.isArray(arg)) {
        return `[ ${join(arg.map(formatArgForLog), ', ')} ]`;
      } else {
        const entries = Object.entries(arg);
        return `{ ${entries
          .map(([key, value]) => `${key} = ${formatArgForLog(value)}`)
          .join(', ')} }`;
      }
    case 'boolean':
    case 'number':
    case 'undefined':
      return `${arg}`;
    case 'function':
      return `f() ${arg.name}`;
    default:
      return `[${argType}] ${arg}`;
  }
};
